import {store} from '../store'
import {firestore} from '../plugins/firebase'
import _get from 'lodash/get'
import { DateTime, Interval } from 'luxon'
import { SATISFACTION_SURVEY } from '../constants/const'
import { getSatisfactionSurveyConstants } from './helpers'

const updateSatisfactionSurveyInfo = async function (functionality, updateLastActivityDate = false) {
  // If curret user is virtualized, do not update satisfaction survey information
  if (store.getters.impersonatedUserId || store.getters.user.isAdmin) return {}

  const db = await firestore
  return await db.runTransaction(async transaction => {
    const userRef = db.collection('app/v1/users').doc(store.getters.user.id)
    const userDoc = await transaction.get(userRef)

    let useFunctionalityCount = updateLastActivityDate ? 0 : _get(userDoc.data(), `satisfactionSurvey.mobileApp.${functionality}.count`, 0) + 1

    // If lastActivityDate doesnt exists, return the first date possible
    let lastActivityDate = _get(userDoc.data(), `satisfactionSurvey.mobileApp.${functionality}.lastActivityDate`)
    lastActivityDate = updateLastActivityDate ? new Date() : (lastActivityDate ? lastActivityDate.toDate() : new Date(0))

    await transaction.update(userRef, {
      [`satisfactionSurvey.mobileApp.${functionality}`]: {
        count: useFunctionalityCount,
        lastActivityDate
      }
    })
    return {count: useFunctionalityCount, lastActivityDate}
  })
}

const saveSatisfactionSurveyResponse = async function (surveyId, user, functionality, question, response) {
  const db = await firestore
  if (!surveyId) {
    // If surveyId is undefined, create new satisfaction survey document
    const userRole = Object.keys(user.roles).find(role => user.roles[role])
    const newSurveyDoc = await db.collection('app/v1/satisfactionSurveys').add({
      appName: 'reports',
      functionality,
      organization: db.collection('app/v1/organizations').doc(store.getters.userOrganization.id),
      questions: [{question: question.text, type: question.type, answer: response}],
      score: response,
      user: db.collection('app/v1/users').doc(user.id),
      userRole,
      createdAt: new Date()
    })
    surveyId = newSurveyDoc.id
  } else {
    // If surveyId is a valid Firestore ID, update the document with new survey answers
    await db.runTransaction(async (transaction) => {
      const surveyRef = db.collection('app/v1/satisfactionSurveys').doc(surveyId)
      const surveyDoc = await transaction.get(surveyRef)
      await transaction.update(surveyRef, {
        questions: [
          ...surveyDoc.data().questions,
          {
            question: question.text,
            type: question.type,
            answer: response
          }
        ]
      })
    })
  }
  return surveyId
}

const showSatisfactionSurvey = async function (count, lastActivityDate, functionality) {
  const satisfactionSurveyConstants = await getSatisfactionSurveyConstants()
  const timeDiff = Interval.fromDateTimes(DateTime.fromJSDate(lastActivityDate), DateTime.now()).length(_get(store, 'getters.satisfactionSurveyConstants.cooldowns.unit', SATISFACTION_SURVEY.DEFAULT_COOLDOWN_UNIT))

  return (
    !store.getters.impersonatedUserId &&
    count >= _get(satisfactionSurveyConstants, `counters.${functionality}`, SATISFACTION_SURVEY.DEFAULT_COUNT) &&
    timeDiff >= _get(satisfactionSurveyConstants, `cooldowns.${functionality}`, SATISFACTION_SURVEY.DEFAULT_COOLDOWN)
  )
}

export {
  updateSatisfactionSurveyInfo,
  saveSatisfactionSurveyResponse,
  showSatisfactionSurvey
}



// WEBPACK FOOTER //
// ./src/lib/satisfaction-surveys.js